import { __decorate } from "tslib";
import { attr, DOM } from '@microsoft/fast-element';
import { Select } from '@microsoft/fast-foundation';
import { SVG_CHEVRON_DOWN } from '@getgo/chameleon-icons';
import { ChameleonElementMixin } from '../common/ChameleonElement';
const helperTextDefaultColor = 'text-02';
export class SelectComponent extends ChameleonElementMixin(Select) {
    constructor() {
        super();
        this.selectedValue = '';
        this.fullwidth = false;
        this.labelHtmlElement = document.createElement('chameleon-typography');
        this.labelHtmlElement.setAttribute('variant', 'button-text-small');
        this.labelHtmlElement.classList.add('label');
        this.helperTextHtmlElement = document.createElement('chameleon-typography');
        this.helperTextHtmlElement.setAttribute('variant', 'caption-default-01');
        this.helperTextHtmlElement.setAttribute('color', helperTextDefaultColor);
    }
    selectedValueChanged(_oldValue, newValue) {
        this.value = newValue;
    }
    labelChanged(_oldValue, newValue) {
        this.labelHtmlElement.innerHTML = newValue;
    }
    helperTextChanged(_oldValue, newValue) {
        this.helperTextHtmlElement.innerHTML = newValue;
    }
    successChanged(_oldValue, newValue) {
        if (newValue) {
            this.helperTextHtmlElement.setAttribute('color', 'text-success-01');
        }
        else {
            this.helperTextHtmlElement.removeAttribute('color');
        }
    }
    errorChanged(_oldValue, newValue) {
        if (newValue) {
            this.helperTextHtmlElement.setAttribute('color', 'danger-01');
        }
        else {
            this.helperTextHtmlElement.removeAttribute('color');
        }
    }
    disabledChanged(_oldValue, newValue) {
        var _a, _b, _c, _d;
        if (newValue) {
            (_a = this.helperTextHtmlElement) === null || _a === void 0 ? void 0 : _a.setAttribute('color', 'text-03');
            (_b = this.labelHtmlElement) === null || _b === void 0 ? void 0 : _b.setAttribute('color', 'text-03');
        }
        else {
            (_c = this.helperTextHtmlElement) === null || _c === void 0 ? void 0 : _c.setAttribute('color', helperTextDefaultColor);
            (_d = this.labelHtmlElement) === null || _d === void 0 ? void 0 : _d.setAttribute('color', 'text-01');
        }
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.querySelector('[slot="indicator"]')) {
            this.createIndicator();
        }
        this.insertLabel();
        this.insertHelperText();
        this.setInitialSelectedValue();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.labelHtmlElement.remove();
        this.helperTextHtmlElement.remove();
    }
    createIndicator() {
        const indicator = document.createElement('chameleon-svg');
        indicator.setAttribute('slot', 'indicator');
        indicator.innerHTML = SVG_CHEVRON_DOWN;
        this.appendChild(indicator);
    }
    insertLabel() {
        var _a;
        if (this.label) {
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.prepend(this.labelHtmlElement);
        }
    }
    insertHelperText() {
        var _a;
        if (this.helperText) {
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.append(this.helperTextHtmlElement);
        }
    }
    setInitialSelectedValue() {
        const selectedValue = this.getAttribute('selected-value');
        if (selectedValue !== null) {
            // because fast wait a frame before querying options
            DOM.queueUpdate(() => {
                this.value = selectedValue;
            });
        }
        else {
            this.selectedValue = this.value;
        }
    }
}
__decorate([
    attr({ attribute: 'selected-value' })
], SelectComponent.prototype, "selectedValue", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SelectComponent.prototype, "success", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SelectComponent.prototype, "error", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SelectComponent.prototype, "inline", void 0);
__decorate([
    attr
], SelectComponent.prototype, "label", void 0);
__decorate([
    attr({ attribute: 'helper-text' })
], SelectComponent.prototype, "helperText", void 0);
__decorate([
    attr({ mode: 'boolean' })
], SelectComponent.prototype, "fullwidth", void 0);
